import { REMOVE_BG_IMGS } from '../services/piezas';
import { toast } from 'react-toastify';
import { setErrorMessage } from './functionalities';

/**
 * Helper para descargar imágenes en segundo plano
 * La tarea continúa ejecutándose aunque el componente se desmonte
 */
class BackgroundImageDownloader {
    constructor() {
        this.activeTasks = new Set();
    }

    /**
     * Inicia la descarga de imágenes en segundo plano
     * @param {Array} imgsUrl - Array de URLs de imágenes
     * @param {number|string} partId - ID de la pieza para nombrar las imágenes
     */
    async downloadImages(imgsUrl, partId) {
        if (!imgsUrl || imgsUrl.length === 0) {
            return;
        }

        const taskId = `download-${Date.now()}-${Math.random()}`;
        this.activeTasks.add(taskId);

        try {
            // Ejecutar la petición en segundo plano
            const res = await REMOVE_BG_IMGS.removeBg(imgsUrl);
            
            if (res?.success && res.data) {
                // Descargar las imágenes automáticamente con el ID de la pieza
                this.triggerDownloads(res.data, partId);
                toast.success(`Se descargaron ${res.data.length} imagen(es) correctamente`);
            } else {
                toast.error('No se pudieron procesar las imágenes');
            }
        } catch (error) {
            toast.error(setErrorMessage(error));
        } finally {
            this.activeTasks.delete(taskId);
        }
    }

    /**
     * Descarga las imágenes procesadas
     * @param {Array} images - Array de imágenes con image_base64
     * @param {number|string} partId - ID de la pieza para nombrar las imágenes
     */
    triggerDownloads(images, partId) {
        if (!images || !Array.isArray(images)) {
            return;
        }

        images.forEach((img, index) => {
            if (img.image_base64) {
                const link = document.createElement('a');
                link.href = img.image_base64;
                // Nombre: pieza_{id}_{numero}.png (ej: pieza_123_1.png, pieza_123_2.png)
                const imageNumber = index + 1;
                const fileName = partId ? `pieza_${partId}_${imageNumber}.png` : `image_${imageNumber}.png`;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        });
    }

    /**
     * Verifica si hay tareas activas
     */
    hasActiveTasks() {
        return this.activeTasks.size > 0;
    }
}

// Exportar una instancia singleton
export const backgroundImageDownloader = new BackgroundImageDownloader();

